/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { calendarSelector } from '@/helpers/props';
import { setBasicFilters } from '@/redux/store/actions/search';
import CalendarMobile from './calendarMobile/CalendarMobile';
import useSearchParams from '@/components/search/hooks/useSearchParams';
import CalendarDesktop from './calendarDesktop/CalendarDesktop';
import useDevice from '@/hooks/useDevice';
interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  handleDatePickerChange: any;
  handleReset: (e: React.MouseEvent<HTMLButtonElement> | boolean) => void;
  withTooltip?: boolean;
  headerChildrenMobile?: React.ReactNode;
}
const DatePicker = ({
  open,
  setOpen,
  handleDatePickerChange,
  handleReset = () => false,
  withTooltip = false,
  headerChildrenMobile
}: Props) => {
  const calendar = useSelector(state => calendarSelector(state, 'searchCalendar'));
  const {
    checkin,
    checkout,
    guests
  } = useSelector(state => state.basicFilters);
  const {
    isMobile
  } = useDevice();
  const dispatch = useDispatch();
  const calendarRef = React.useRef<any>(null);
  const handleClose = () => {
    setOpen(false);
  };
  const resetFilter = (e: React.MouseEvent<HTMLButtonElement>, shouldClose = false) => {
    e.stopPropagation();
    calendarRef.current?.cleanValue();
    dispatch(setBasicFilters({
      checkin: null,
      checkout: null,
      guests
    }));
    if (handleReset) {
      handleReset(shouldClose);
    }
  };
  return <>
      {!isMobile ? <CalendarDesktop open={open} checkin={checkin} checkout={checkout} calendarRef={calendarRef} handleChange={handleDatePickerChange} calendar={calendar} withTooltip={withTooltip} /> : <>
          <CalendarMobile onClose={handleClose} open={open} handleDatePickerChange={handleDatePickerChange} resetFilter={resetFilter} calendarRef={calendarRef} withTooltip={withTooltip} headerChildren={headerChildrenMobile} />
        </>}
    </>;
};
export default React.memo(DatePicker);